'use strict';

class Code {
    private code: string;

    constructor(code: string) {
        this.code = code;
    }

    toString() {
        return this.code;
    }

}

export default Code;
